import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import * as CronofyElements from "cronofy-elements";
import PropTypes from "prop-types";
import "./date-time-picker.scss";
import { GiraffeLoader } from "hireart-components";
import { cn, ErrorMessage } from "@hireart/component-library";
import { GET_CRONOFY_ELEMENT_TOKEN } from "../get-cronofy-element-token";
import { getConfig } from "../util";
import { TARGET_ID } from "./constants";

export const DateTimePicker = ({
  className = "",
  interviewerIds,
  durationInMinutes = undefined,
  selectedDate,
  onDurationMissingError,
  onError,
  onSlotSelected = () => {},
  isReadOnly = false,
}) => {
  const [element, setElement] = useState(null);
  const {
    data = {},
    loading: isLoading,
    error,
  } = useQuery(GET_CRONOFY_ELEMENT_TOKEN, {
    variables: { subs: interviewerIds, user: null },
  });
  const { elementToken } = data;
  const hasError = !!error;
  const options = getConfig({
    elementToken,
    interviewerIds,
    durationInMinutes,
    selectedDate,
    onDurationMissingError,
    onError,
    onSlotSelected,
    isReadOnly,
    targetId: TARGET_ID,
  });

  useEffect(() => {
    if (!element && elementToken) {
      setElement(CronofyElements.DateTimePicker(options));
    } else if (elementToken) {
      element.update(options);
    }
  }, [element, options, elementToken]);

  return (
    <>
      {isLoading && <GiraffeLoader />}
      {hasError && (
        <ErrorMessage className="[&_a:hover:visited]:!text-blue-80 [&_a:hover]:!text-purple-60 [&_a]:!underline" />
      )}
      {/* The root DATE_TIME_PICKER_TARGET_ID element must always be available in the DOM for Cronofy injection to work. Using .hidden to visually hide BUT still render the element in the DOM when the element token is loading, etc. */}
      <div
        className={cn(
          { hidden: isLoading || hasError },
          { "read-only": isReadOnly },
          className
        )}
        id={TARGET_ID}
      />
    </>
  );
};

DateTimePicker.propTypes = {
  className: PropTypes.string,
  durationInMinutes: PropTypes.number,
  selectedDate: PropTypes.string.isRequired, // YYYY-MM-DD
  interviewerIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onDurationMissingError: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onSlotSelected: PropTypes.func,
  isReadOnly: PropTypes.bool,
};
